import React from 'react'
import Table from 'react-bootstrap/Table';
import AuthNavbar from '../components/AuthNavbar/AuthNavbar';
import { Container } from 'react-bootstrap';
import HomeTitle from "../components/HomeTitle/HomeTitle"
import { useSelector } from 'react-redux';

function TimeTable() {
              const { currentLocal } = useSelector((state) => state.currentLocal);
    
  return (
    <div className="px-0 my-3 w-100 dashboard_content h-75">
    <Container className='h-100'>
        <div className="d-flex flex-column w-100 h-100">
          <AuthNavbar />
                      <div className="my-5 mx-3">

            <Table striped bordered hover>
      <thead>
        <tr>
          <th>{currentLocal.home.Day}</th>
          <th>{currentLocal.home.Session} 1</th>
          <th>{currentLocal.home.Session} 2</th>
          <th>{currentLocal.home.Session} 3</th>
          <th>{currentLocal.home.Session} 4</th>
          <th>{currentLocal.home.Session} 5</th>
          <th>{currentLocal.home.Session} 6</th>
          <th>{currentLocal.home.Session} 7</th>
          <th>{currentLocal.home.Session} 8</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{currentLocal.home.sunday}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
        </tr>
        <tr>
          <td>{currentLocal.home.saturday}</td>
              <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>

        </tr>
        <tr>
          <td>{currentLocal.home.friday}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
        </tr>
        <tr>
          <td>{currentLocal.home.thursday}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
        </tr>
        <tr>
          <td>{currentLocal.home.wednesday}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
        </tr>
        <tr>
          <td>{currentLocal.home.tuesday}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
        </tr>
        <tr>
          <td>{currentLocal.home.monday}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
          <td>{"arabic (Ahmed)"}</td>
        </tr>
      </tbody>
    </Table>
    </div>
</div>
</Container>
    </div>
  )
}

export default TimeTable